module.exports = __webpack_public_path__ + "static/media/gomoment.14dc5a2f.png";